
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

/**
 * 
 */
export class UmbrellaSearchApi extends runtime.BaseAPI {

    /**
     * Trigger global reindexation of all umbrella companies (admin endpoint)
          */
    async reindexAllUmbrellasRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/admin/reindex-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Trigger global reindexation of all umbrella companies (admin endpoint)
          */
    async reindexAllUmbrellas(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexAllUmbrellasRaw(initOverrides);
    }

}
